import { parse } from "../../services/helpers/config";

// @TODO: refactor

function init(select) {
    const parent = select.parentNode;
    const container = document.createElement("div");
    const options = document.createElement("div");
    const input = document.createElement("input");
    const multiple = select.multiple;
    const settings = parse(select.dataset.select);
    const selectPlaceholder = select.dataset.placeholder;
    const placeholder = settings.float ? "" : selectPlaceholder;
    const pureOptions = {};
    const pureOptionsTexts = [];
    let pureOptionsList = [];

    input.classList.add("uic-select__input");
    input.setAttribute("type", "text");
    options.classList.add("uic-select__options");
    container.classList.add("uic-select");
    container.appendChild(input);
    
    if (settings.float) {
        const label = document.createElement("span");
        label.textContent = selectPlaceholder;
        label.classList.add("uic-select__label");
        container.appendChild(label);
    }
    
    container.appendChild(options);

    if (settings.className) {
        container.classList.add(...settings.className.split(" "));
    }

    if (settings.float) {
        container.classList.add("floatable");
    }

    if (settings.search) {
        container.classList.add("searchable");

        const border = document.createElement("span");
        border.classList.add("uic-select__border");
        container.appendChild(border);
    }
    else {
        input.setAttribute("readonly", true);
    }

    if (multiple) {
        container.classList.add("multiple");
    }

    select.style.display = "none";
    parent.appendChild(container);


    function choose(option) {
        if (!multiple) {
            options.querySelectorAll(".selected")
                .forEach(item => item.classList.remove("selected"));
            pureOptionsList.forEach(i => i.selected = false);
        }

        if ("clear" in pureOptions[option.dataset.value].dataset) {
            input.value = "";
            select.value = "";
        }
        else {
            option.classList.toggle("selected");
            pureOptions[option.dataset.value].selected = !pureOptions[option.dataset.value].selected;
            input.value = pureOptionsList.filter(i => i.selected).map(i => i.textContent.trim()).join(", ");
        }

        input.classList.toggle("placeholder", !input.value);

        if (!input.value) {
            input.value = placeholder;
        }

        select.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }

    function onMouseDown(e) {
        const option = e.target.closest(".uic-select__option");

        if (option) {
            choose(option);

            if (multiple) {
                e.preventDefault();
            }
        }
    }

    function filter(value) {
        value = value.toLowerCase();

        for (const key in pureOptions) {
            const optionText = pureOptions[key].textContent.toLowerCase();

            options.querySelector(`[data-value="${key}"]`)
                .classList.toggle("hidden", !optionText.startsWith(value));
        }
    }

    function makeItem(item) {
        const option = document.createElement("div");
        const optionText = document.createElement("span");

        option.classList.add("uic-select__option");
        option.dataset.value = item.value;
        optionText.classList.add("uoc-select__option-text");
        optionText.textContent = item.textContent.trim();

        if (multiple) {
            const optionMark = document.createElement("span");
            optionMark.classList.add("ico", "mr-2");
            optionMark.innerHTML = '<svg width="18" height="18"><use xlink:href="#check-icon" href="#check-icon"></svg>';
            option.appendChild(optionMark);
        }

        if (item.hidden) {
            option.classList.add("d-none");
        }

        option.appendChild(optionText);

        pureOptions[item.value] = item;

        options.appendChild(option);
    }

    select.querySelectorAll("option").forEach(makeItem);
    pureOptionsList = Object.values(pureOptions).filter(i => !i.disabled);

    options.addEventListener("mousedown", onMouseDown);
    options.addEventListener("touchstart", e => onMouseDown(e.touches[0]));

    function applySelect() {
        Array.from(select.selectedOptions)
            .forEach(i => options.querySelector(`[data-value="${i.value}"]`).classList.add("selected"));

        input.value = pureOptionsList.filter(i => i.selected).map(i => i.textContent.trim()).join(", ");
        input.classList.toggle("placeholder", !input.value || input.value === placeholder);

        if (!input.value) {
            input.value = placeholder;
        }
    };

    applySelect();

    select.addEventListener("select.change", applySelect);

    input.addEventListener("focus", e => {
        container.classList.add("opened");
    });

    input.addEventListener("blur", e => {
        container.classList.remove("opened");
    });

    if (settings.search) {
        const resetInput = () => {
            input.classList.add("placeholder");
            input.value = placeholder;
            select.value = null;
        };

        input.addEventListener("focus", () => {
            let value = input.value;

            if (select.selectedIndex !== -1) {
                value = "";
            }

            filter(value);
            input.classList.remove("placeholder");
        });

        input.addEventListener("blur", () => {
            if (!input.value) {
                resetInput();
            }
            else {
                input.value = pureOptionsList
                    .filter(i => i.selected)
                    .map(i => i.textContent.trim())
                    .join(", ");
                
                if (!input.value) {
                    resetInput();
                }
            }
        });
    }

    if (settings.search === "local") {
        input.addEventListener("input", () => filter(input.value));
    }

    return {
        add({ value, text, hidden = false }) {
            if (!(value in pureOptions)) {
                const option = document.createElement("option");

                option.value = value;
                option.textContent = text || value;
                option.hidden = hidden;

                select.appendChild(option);
                makeItem(option);

                if (!hidden) {
                    pureOptionsList.push(option);
                }
            }
        },

        clear() {
            while (select.firstChild) {
                select.removeChild(select.firstChild);
            }
            
            while (options.firstChild) {
                options.removeChild(options.firstChild);
            }

            for (const key in pureOptions) {
                delete pureOptions[key];
            }

            pureOptionsList.length = 0;
        },

        filter() {
            filter(input.value);
        },

        enableAll() {
            options.querySelectorAll("[data-value]")
                .forEach(option => option.classList.remove("hidden"));
        },

        select(value) {
            const option = options.querySelector(`[data-value="${ value }"]`);

            if (option) {
                choose(option);
            }
        },

        input: input
    };
}

export { init };
